import React, { useState, useEffect } from "react";
import { Award, Star, Trophy, Medal, Heart } from "lucide-react";
import award1 from "../../assets/image/award_1.png";
import award2 from "../../assets/image/award_2.png";
import award3 from "../../assets/image/award_3.png";
import award4 from "../../assets/image/award_4.png";

const GetPrize = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const organizationPrizes = [
    {
      id: 1,
      name: "দৈনিক ইনফো বাংলা পত্রিকা কর্তৃক বিশেষ সম্মাননা",
      year: 2024,
      description: "মানবসেবা মূলক কাজে অবদান রাখায় বিশেষ সম্মাননা প্রাপ্তি",
      organization: "দৈনিক ইনফো বাংলা পত্রিকা",
      icon: <Award className="w-6 h-6" />,
      color: "bg-blue-100 text-blue-800",
      borderColor: "border-blue-200",
      image: award1,
    },
    {
      id: 2,
      name: "আমরা সবাই সনাতনী সংগঠন কর্তৃক বিশেষ সম্মাননা",
      year: 2024,
      description:
        "চট্টগ্রামের পরিচিত সংগঠন থেকে মানবসেবা মূলক কাজে অবদানের স্বীকৃতি",
      organization: "আমরা সবাই সনাতনী সংগঠন",
      icon: <Trophy className="w-6 h-6" />,
      color: "bg-green-100 text-green-800",
      borderColor: "border-green-200",
      image: award2,
    },
    {
      id: 3,
      name: "মুক্তি ব্লাড ব্যাংক প্রতিষ্ঠাবার্ষিকী সম্মাননা",
      year: 2024,
      description:
        "ফ্রি রক্তদান ও মেডিকেল ক্যাম্প কর্মসূচিতে অবদানের জন্য বিশেষ সম্মাননা",
      organization: "মুক্তি ব্লাড ব্যাংক, চট্টগ্রাম",
      icon: <Heart className="w-6 h-6" />,
      color: "bg-red-100 text-red-800",
      borderColor: "border-red-200",
      image: award3,
    },
    {
      id: 4,
      name: "গীতাঞ্জলি মাতৃ সংঘ কর্তৃক বিশেষ সম্মাননা",
      year: 2024,
      description:
        "মানবসেবা মূলক কাজে অবদান রাখায় চট্টগ্রামের পরিচিত সংগঠন থেকে সম্মাননা",
      organization: "গীতাঞ্জলি মাতৃ সংঘ, চট্টগ্রাম",
      icon: <Medal className="w-6 h-6" />,
      color: "bg-amber-100 text-amber-800",
      borderColor: "border-amber-200",
      image: award4,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      {/* Main Content */}
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full mb-6 shadow-md">
            <Trophy className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            প্রাপ্ত পুরস্কার সমূহ
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-orange-500 mx-auto rounded-full mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            আমাদের মানবসেবায় অবদানের স্বীকৃতিস্বরূপ প্রাপ্ত সম্মাননা সমূহ
          </p>
        </div>

        {/* Awards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 mb-16">
          {organizationPrizes.map((prize, index) => (
            <div
              key={prize.id}
              className={`relative bg-white rounded-xl shadow-md overflow-hidden border ${
                prize.borderColor
              } transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 ${
                isVisible ? "opacity-100" : "opacity-0"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onMouseEnter={() => setHoveredCard(prize.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="flex flex-col md:flex-row h-full">
                {/* Award Image */}
                <div className="w-full md:w-1/3 h-48 md:h-auto relative overflow-hidden">
                  <img
                    src={prize.image}
                    alt={prize.name}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>

                {/* Award Content */}
                <div className="w-full md:w-2/3 p-6 flex flex-col">
                  <div className="flex items-center justify-between mb-3">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${prize.color}`}
                    >
                      {prize.year}
                    </span>
                    <div
                      className={`p-2 rounded-lg ${prize.color} bg-opacity-20`}
                    >
                      {prize.icon}
                    </div>
                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">
                    {prize.name}
                  </h2>

                  <p className="text-gray-600 mb-4 flex-grow">
                    {prize.description}
                  </p>

                  <div className="pt-3 border-t border-gray-100">
                    <p className="text-sm text-gray-500">
                      প্রদানকারী:{" "}
                      <span className="font-medium text-gray-700">
                        {prize.organization}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="bg-white rounded-xl shadow-md p-8 text-center border border-gray-200">
          <div className="flex justify-center items-center space-x-3 mb-6">
            <Heart className="w-6 h-6 text-red-500" />
            <h3 className="text-2xl font-bold text-gray-900">
              আমাদের অঙ্গীকার
            </h3>
            <Heart className="w-6 h-6 text-red-500" />
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-4xl mx-auto leading-relaxed">
            <span className="font-semibold text-gray-800">
              উক্ত বিশেষ সম্মাননা সমূহ আমাদের সেবামূলক পথচলাকে আরও সুদৃঢ় করে
              তোলেছে।
            </span>{" "}
            সমাজের কল্যাণে আমাদের অবদান অব্যাহত রাখতে আমরা প্রতিশ্রুতিবদ্ধ।
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="px-6 py-3 bg-primary  text-white font-medium rounded-lg transition-colors duration-300 shadow-sm hover:shadow-md flex items-center justify-center space-x-2">
              <Heart className="w-5 h-5" />
              <span>আমাদের সাথে যুক্ত হন</span>
            </button>

            <button className="px-6 py-3 bg-secondary  text-white font-medium rounded-lg transition-colors duration-300 shadow-sm hover:shadow-md flex items-center justify-center space-x-2">
              <Trophy className="w-5 h-5" />
              <span>আরও জানুন</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetPrize;
